module.exports = __webpack_public_path__ + "static/img/sxb-edu.8a03582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/sxb-edu.png
// module id = 4ldD
// module chunks = 0